var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-switch" },
    [
      _c("v-switch", {
        attrs: {
          "input-value": _vm.value,
          label: _vm.label,
          error: _vm.hasError,
          readonly: _vm.readonly,
          disabled: _vm.disabled,
          "hide-details": _vm.hideDetails,
          "true-value": _vm.trueValue,
          "false-value": _vm.falseValue,
          "error-messages": _vm.$formErrors(_vm.v),
          color: "secondary",
        },
        on: { change: _vm.change },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }